<drawer *ngIf="documentResult" [title]="showDeterminantBuilder ? 'Result - Determinant' : documentResult.id ? 'Edit Result' : 'Add Result'"
	[showHeaderButtons]="true"
	[hideDelete]="true"
	[hideCancel]="false"
	[hideSave]="false"
	[contextLabel]="documentResult?.requirement?.name || ('Result ' + (documentResult.id ? documentResult.id : ''))"
	[noContentPadding]="showDeterminantBuilder"
	[isClosed]="false"
	(saveEvent)="submit()"
	(cancelEvent)="closeLayer()"
	(closeEvent)="closeLayer()">
	<div class="drawer-content drawer-direct-content">
		<div *ngIf="showDeterminantBuilder" class="d-flex overflow-hidden mh-100 h-100 w-100">
			<determinant-new
				*ngIf="store.state.common.determinantSection.topLayer === 'edit'"
				class="d-flex overflow-hidden mh-100 w-100 flex-column"
				[serviceId]="serviceId"
				[determinant]="store.state.common.determinantSection.determinant"
				[isEmbedded]="false"
				[isClosed]="false"
				(formSubmit)="closeDetLayer()"
				(editCancel)="closeDetLayer()"
			></determinant-new>
			<div class="overflow-hidden mh-100 h-100 w-100 {{store.state.common.determinantSection.topLayer === 'edit' ? 'd-none' : 'd-flex'}} flex-column">
				<div class="mb-0 no-gutters row h-100 overflow-hidden w-100">
					<div class="col list-determinants h-100 mh-100">
						<determinant-list
							class="d-flex overflow-hidden mh-100 h-100 flex-column flex-grow-0 py-3 pl-3"
							[groupsLength]="{value: documentResult.jsonDeterminants}"
							[prefix]="'rese'"
							[determinantMapById]="determinantMapById"
							[addDeterminantTo]="appendDeterminant"></determinant-list>
					</div>
					<div class="col pl-2 pb-3 query-builder">
						<query-builder *ngIf="documentResult" [determinantMapById]="determinantMapById"
							[ngClass]="'fixed scrolleable'"
							[prefix]="'rese'"
							[jsonString]="documentResult.jsonDeterminants"
							(onChange)="documentResult.jsonDeterminants = $event.jsonString"></query-builder>
					</div>
				</div>
			</div>
		</div>
		
		<div *ngIf="!showDeterminantBuilder" class="row">
			<div class="col-12">
				<form name="itemForm" role="form">
					<div class="d-flex my-4 py-2 row fields-group {{ showDeterminantBuilder ? 'hidden' : '' }}">
						<div class="col align-items-center d-flex pl-0">
							<span (click)="documentResult.resultIsPhysical = !documentResult.resultIsPhysical"
								tooltip="{{ 'modal.result_is_physical' | translate }}"
								placement="right"
								class="btn btn-circle-medium btn-circle-icon mr-2 btn-toggle btn-default {{ documentResult.resultIsPhysical ? 'active' : ''}}"><i class="far fa-box"></i></span>
							<span (click)="documentResult.resultIsDigital = !documentResult.resultIsDigital"
								tooltip="{{ 'modal.result_is_digital' | translate }}"
								placement="right"
								class="btn btn-circle-medium btn-circle-icon mr-2 btn-toggle btn-success {{ documentResult.resultIsDigital ? 'active' : ''}}"><i class="far fa-cloud-arrow-down"></i></span>
							<span (click)="documentResult.multiple = !documentResult.multiple;"
								tooltip="{{ 'modal.result_is_multiple' | translate }}"
								placement="right"
								class="btn btn-circle-medium btn-circle-icon mr-2 btn-toggle btn-secondary {{ documentResult.multiple ? 'active' : ''}}">
								<i class="fa-solid fa-files"></i>
							</span>
							<span *ngIf="documentResult.linkingFileUploadPath"
								tooltip="{{ 'modal.result_is_linked_with_file_upload_component' | translate }} - {{ documentResult.linkingFileUploadPath }}"
								placement="right"
								class="btn btn-circle-medium btn-circle-icon mr-2 btn-secondary"
								[routerLink]="documentResult.linkingFileUploadPathRouterLink"><i class="far fa-cloud-arrow-up"></i></span>
						</div>
						<div class="col-auto page-actions-container py-0 d-flex align-items-center px-1">
							<a *ngIf="(documentResult.requirement && documentResult.requirement.fileId) || documentResult.fileId"
								(click)="download(documentResult)"
								download
								class="btn btn-circle-small btn-circle-icon btn-light">
								<i tooltip="{{ 'Download file' | translate }}"
									placement="left" class="fal fa-file"></i>
							</a>
							<label class="btn-light btn btn-circle-small btn-circle-icon mx-1">
								<i tooltip="{{ 'Upload or change uploaded file' | translate }}" placement="left" class="{{((documentResult.requirement && documentResult.requirement.fileId) || documentResult.fileId) ? 'far fa-pen' : 'fal fa-file'}}"></i>
								<file-uploader
									[item]="documentResult.requirement ? documentResult.requirement : documentResult"
									(fileIdChanged)="handleUpload($event, documentResult.requirement ? documentResult.requirement : documentResult)"
								></file-uploader>
							</label>
							<a *ngIf="(documentResult.requirement && documentResult.requirement.fileId) || documentResult.fileId"
								class="btn-bordered btn-danger btn-icon btn-xs d-flex align-items-center"
								(click)="deleteFile(documentResult)">
								<i tooltip="{{ 'Erase file' | translate }}"placement="left" class="fas fa-times"></i>
							</a>
						</div>
						<div class="col-auto align-items-center d-flex pr-0" *ngIf="documentResult?.requirement?.businessKey" >
							<business-key
								[businessKey]="documentResult?.requirement?.businessKey"
								[businessKeyTooltip]="'Result business key' | translate"></business-key>
						</div>
					</div>
					<div class="row fields-group {{ showDeterminantBuilder ? 'hidden' : '' }}">
						<div class="col-12 mb-4">
							<label class="input-label">{{'Result name' | translate}}</label>
							<input
								class="form-control"
								placeholder="{{ 'Result name' | translate }}"
								[(ngModel)]="documentResult.requirement.name"
								type="text"
								name="title"
								#vname="ngModel"
								[rangeLength]="[2, 256]"
								required
								autofocus
							/>
							<p class="validation-error"
								*ngIf="vname && vname.errors?.required && (vname?.dirty && vname?.touched)">
								{{ 'form.validate.required' | translate }}
							</p>
							<p class="validation-error" *ngIf="vname && vname.errors?.rangeLength && (vname?.dirty && vname?.touched)">
								{{ 'form.validate.minLenght' | translate }} 2!
							</p>
							<p class="validation-error" *ngIf="vname && vname.errors?.rangeLength && (vname?.dirty && vname?.touched)">
								{{ 'form.validate.maxLenght' | translate }} 256!
							</p>
						</div>
						<div class="col-12">
							<label class="input-label">{{'modal.comment_in_context' | translate}}</label>
							<textarea
								class="form-control"
								name="additionalInformation"
								[(ngModel)]="documentResult.additionalInformation"
								rows="1"
							></textarea>
						</div>
					</div>

					<app-list-grid class="col-md-12 my-3" nameFieldKey="title" [items]="documentResult.requirement.types"
								[nameFieldKey]="'type'" [toggleIcons]="false" [badgeIcons]="true" [sortable]="false" [expanded]="true"
								[navigationEdit]="false" [showAddWithoutSearch]="true" [hideSearch]="true" [inlineAdd]="false" [showAttributes]="false"
								[addText]="'Add new document type'" [determinantMapById]="determinantMapById"
								(createFunction)="addDocumentType($event)"
								(deleteFunction)="deleteDocumentType($event)"
								headingText="modal.document_type" headingTextSize="SMALL" hidden>
					</app-list-grid>

					<div class="row mb-3 {{ showDeterminantBuilder ? 'hidden' : '' }}" hidden>
						<div class="col-12">
							<label class="input-label">{{'modal.document_type' | translate}}</label>
							<input
								class="form-control"
								placeholder="{{ 'Document code for BOT' | translate }}"
								[(ngModel)]="documentResult.requirement.documentCode"
								type="text"
								name="documentCode"
								#name="ngModel"
							/>
						</div>
					</div>
					<div *ngIf="showBotSelection()" class="row fields-group {{ showDeterminantBuilder ? 'hidden' : '' }}">
						<div class="col" *ngIf="availableDocumentBots.length > 0">
							<div class="row">
								<div class="col">
									<label class="input-label">{{ 'Document bot' | translate }}</label>
								</div>
							</div>
							<div class="row align-items-center">
								<div class="col">
									<select
											class="form-control ng-pristine ng-invalid ng-invalid-required ng-touched mr-auto"
											[(ngModel)]="documentResult.bot" nameFieldKey="title" name="bot">
										<option [ngValue]="null"></option>
										<option *ngFor="let bot of availableDocumentBots" [ngValue]="bot">{{bot.name}}</option>
									</select>    
								</div>
								<div class="col-auto">
									<a class="btn btn-primary" target="_blank" [routerLink]="['/services/' + serviceId + '/bots']">
										<span>{{ 'Create new bot' | translate }}</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</drawer>